import actions from '../action/area'
import CONSTANT from '../constant/area'
export default {
    actions,
    state: {
        provinceList: [{name:"(╯‵□′)╯︵┻━┻ }"}, {name:"网络不行了"}],
        cityList: [{name:"(╯‵□′)╯︵┻━┻ }"}, {name:"网络不行了"}],
        districtList: [{name:"(╯‵□′)╯︵┻━┻ }"}, {name:"网络不行了"}],
        showPicker: false,
        selected: {
            province: {},
            city: {},
            district: {},
        }
    },
    mutations: {
        changePickerStatus(state) {
            return state.showPicker = !state.showPicker
        },
        changeSelected(state,data) {
            return state.selected = data 
        },

        [CONSTANT.AREA_GETPROVINCE_SUCCESS] (state, data) {
            return state.provinceList = data
        },
        [CONSTANT.AREA_GETPROVINCE_ERROR] (state, e) {
            
        },
        [CONSTANT.AREA_GETCITY_SUCCESS] (state, data) {
            return state.cityList = data
        },
        [CONSTANT.AREA_GETCITY_ERROR] (state, e) {
             
        },
        [CONSTANT.AREA_GETDISTRICT_SUCCESS] (state, data) {
            return state.districtList = data
        },
        [CONSTANT.AREA_GETDISTRICT_ERROR] (state, e) {
            
        },
        /*yeoman-template-point-1*/
    }
}